import { render } from "./PillControl.vue?vue&type=template&id=5418500f"
import script from "./PillControl.vue?vue&type=script&lang=js"
export * from "./PillControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__